import React, { useState } from "react";
import { Filters } from "./filter";
import { useSelector } from 'react-redux';
import { Close, Filter, PowerOff } from "./icons";
import { isMobile } from '../utils/index';
import { Form, Nav, Tab } from "react-bootstrap";
import menuList from '../routes/menu';
import { Link, useNavigate, useLocation } from "react-router-dom";
import clsx from "clsx";
import { AppModalMod } from "./modal";

const MobileLayout = React.memo(({ useFilter }: any) => {
    const [openFilter, setOpenFilter] = useState(false)
    return <>
        <div className="d-flex flex-column">
            <div className="w-100 d-flex justify-content-between ">
                <Form.Select className="select">
                    <option style={{ color: "gray" }}>Menu</option>
                </Form.Select>
                <span onClick={() => setOpenFilter(!openFilter)}><Filter className="fa-2x" /></span>
            </div>
        </div>
        {openFilter ?
            <div className="backdrop" >
                <div className="d-flex flex-column w-100 p-2  justify-content-between ">
                    <div className="d-flex mb-5 justify-content-end">
                        <Close className="fa-2x text-white" onClick={() => setOpenFilter(!openFilter)} />
                    </div>
                    {useFilter && <Filters />}
                </div>
            </div> : null}
    </>
})

export default function LeftBar({ children }: { children: JSX.Element }): JSX.Element {
    const { useFilter, pageTitle = '' } = useSelector((state: any) => state.appReducer.pageSettings) || {};
    const user = useSelector((state: any) => state.appReducer.userInfo) || {};
    const [openFilter, setOpenFilter] = useState(false)
    const navigate = useNavigate();
    return <div className="d-flex p-3 flex-column ">
        <div className="w-100 mb-4 d-flex justify-content-between ">

        </div>
        {useFilter && <span onClick={() => { setOpenFilter(!openFilter) }} className="mobile-filter clickable w-100 justify-content-end"><Filter className="fa-2x" /></span>}
        {useFilter && <div className="w-10 mt-1 mb-3 filter-container ">
            <Filters />
        </div>
        }

        <Tab.Container>
            <div className="main-view">
                {children}
            </div>

        </Tab.Container>
        <AppModalMod show={openFilter} closeModal={() => setOpenFilter(!openFilter)} >
            <Filters />
        </AppModalMod>

    </div>
}

